<template>
  <div id="app">
    <!-- <Header></Header> -->
    <router-view/>
    <!-- <Footer></Footer> -->
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
	/* 全局样式 */
	::-webkit-scrollbar {
	    width: 8px; /* 设置滚动条宽度 */
	}
	 
	/* 水平滚动条样式 */
	::-webkit-scrollbar-track {
	    background-color: #f5f5f5; /* 设置滑道背景色 */
	}
	 
	::-webkit-scrollbar-thumb {
	    background-color: #4e96d1; /* 设置滑块背景色 */
	    border-radius: 4px; /* 设置滑块圆角 */
	}
	 
	/* 垂直滚动条样式 */
	::-webkit-scrollbar-corner {
	    display: none; /* 去除交叉点 */
	}
	 
	/* Firefox浏览器支持 */
	@supports (-moz-appearance:none) {
	    ::-moz-scrollbar {
	        width: 8px; /* 设置滚动条宽度 */
	    }
	    
	    ::-moz-scrollbar-track {
	        background-color: #f5f5f5; /* 设置滑道背景色 */
	    }
	    
	    ::-moz-scrollbar-thumb {
	        background-color: #aaa; /* 设置滑块背景色 */
	        border-radius: 4px; /* 设置滑块圆角 */
	    }
	}
</style>



// WEBPACK FOOTER //
// src/App.vue